// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useNavigate } from 'react-router-dom';
// import { Notify } from '../Utility/Notify';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { useTheme } from '@mui/material/styles';
// import CircularProgress from '@mui/material/CircularProgress';
// import Switch from '@mui/material/Switch';
// import { useSidebarWidth } from '../Utility/useSidebarWidth';
// import EditIcon from '@mui/icons-material/Edit';
// import baseurl from '../Api/BaseUrl';

// /* ─────────────────────────────────────────────
//    DESIGN TOKENS  (same as UpdateClient)
// ───────────────────────────────────────────── */
// const T = {
//   navy:        '#0B1437',
//   navyLight:   '#0F1D4A',
//   accent:      '#0D47A1',
//   accentBg:    'rgba(26,60,219,0.08)',
//   white:       '#FFFFFF',
//   offWhite:    '#f0f2f5',
//   surface:     '#FFFFFF',
//   border:      '#DDE3F0',
//   borderLight: '#EEF1FA',
//   text:        '#0B1437',
//   textMuted:   '#6B7694',
//   textLight:   '#9BA5C9',
//   gold:        '#C8A96E',
//   danger:      '#E24B4A',
//   success:     '#1D9E75',
//   labelSize:   '11px',
//   sectionFont: "'DM Sans', 'Georgia', sans-serif",
//   bodyFont:    "'DM Sans', sans-serif",
//   darkBg:      '#0f1117',
//   darkSurface: '#1a1d2e',
//   darkSurface2:'#161929',
//   darkBorder:  '#2a2f45',
//   darkText:    '#e5e7eb',
//   darkMuted:   '#6b7280',
// };

// /* ─────────────────────────
//    Mini Components
// ───────────────────────── */
// const SectionTag = ({ number, label }) => (
//   <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'20px' }}>
//     <div style={{ width:'28px', height:'2px', background: T.accent }} />
//     <span style={{
//       fontFamily: T.bodyFont, fontSize: T.labelSize, fontWeight:'700',
//       letterSpacing:'2px', color: T.accent, textTransform:'uppercase',
//     }}>
//       Section {String(number).padStart(2,'0')} / {label}
//     </span>
//   </div>
// );

// const FieldLabel = ({ children, isDark }) => (
//   <label style={{
//     display:'block', marginBottom:'6px', fontFamily: T.bodyFont,
//     fontSize: T.labelSize, fontWeight:'700', letterSpacing:'1.5px',
//     textTransform:'uppercase', color: isDark ? T.darkMuted : T.textMuted,
//   }}>
//     {children}
//   </label>
// );

// const getInputStyle = (isDark) => ({
//   width:'100%', padding:'10px 14px', borderRadius:'10px',
//   border:`1.5px solid ${isDark ? T.darkBorder : T.border}`,
//   background: isDark ? T.darkSurface2 : '#FAFBFF',
//   color: isDark ? T.darkText : T.text,
//   fontSize:'13px', fontFamily: T.bodyFont,
//   outline:'none', transition:'border-color .2s, box-shadow .2s', boxSizing:'border-box',
// });

// const SectionCard = ({ children, isDark, style }) => (
//   <div style={{
//     background: isDark ? T.darkSurface : T.surface,
//     border:`1px solid ${isDark ? T.darkBorder : T.border}`,
//     borderRadius:'12px', padding:'28px', marginBottom:'20px', ...style,
//   }}>
//     {children}
//   </div>
// );

// /* ─────────────────────────────────────────────
//    LuxuryAutocomplete  (same as UpdateClient)
// ───────────────────────────────────────────── */
// const getProjectIcon = (name = '') => {
//   const n = name.toLowerCase();
//   if (n.includes('villa') || n.includes('residence')) return '🏡';
//   if (n.includes('beach') || n.includes('leisure') || n.includes('oasis')) return '🏖';
//   if (n.includes('commercial') || n.includes('hub')) return '🏗';
//   if (n.includes('logistic') || n.includes('industrial')) return '🏭';
//   if (n.includes('urban') || n.includes('city')) return '🏙';
//   if (n.includes('luxury') || n.includes('premium')) return '💎';
//   return '🏢';
// };
// const getProjectSubtitle = (name = '') => {
//   const n = name.toLowerCase();
//   if (n.includes('villa')) return 'LUXURY LIVING';
//   if (n.includes('beach') || n.includes('oasis')) return 'LEISURE ESTATES';
//   if (n.includes('commercial') || n.includes('hub')) return 'COMMERCIAL HUB';
//   if (n.includes('logistic')) return 'INDUSTRIAL';
//   if (n.includes('urban')) return 'URBAN PORTFOLIO';
//   if (n.includes('residence') || n.includes('tower')) return 'RESIDENTIAL';
//   return 'REAL ESTATE';
// };

// const LuxuryAutocomplete = ({
//   options = [], value, onChange, placeholder, loading, isDark,
//   getLabel, getSubtitle, getIcon, disabled,
// }) => {
//   const [open,   setOpen]   = useState(false);
//   const [search, setSearch] = useState('');
//   const ref = React.useRef(null);

//   const labelFn    = getLabel    || (o => o?.name || '');
//   const subtitleFn = getSubtitle || (o => getProjectSubtitle(o?.name || ''));
//   const iconFn     = getIcon     || (o => getProjectIcon(o?.name || ''));
//   const filtered   = options.filter(o => labelFn(o).toLowerCase().includes(search.toLowerCase()));

//   useEffect(() => {
//     const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
//     document.addEventListener('mousedown', h);
//     return () => document.removeEventListener('mousedown', h);
//   }, []);

//   return (
//     <div ref={ref} style={{ position:'relative', width:'100%' }}>
//       <div
//         onClick={() => !disabled && setOpen(o => !o)}
//         style={{
//           display:'flex', alignItems:'center', gap:'10px',
//           padding:'0 14px', height:'42px', borderRadius:'10px',
//           border:`1.5px solid ${open ? T.accent : isDark ? T.darkBorder : T.border}`,
//           background: isDark ? T.darkSurface2 : '#FAFBFF',
//           cursor: disabled ? 'not-allowed' : 'pointer',
//           transition:'border-color .2s',
//           boxShadow: open ? `0 0 0 3px rgba(13,71,161,0.08)` : 'none',
//           opacity: disabled ? 0.6 : 1, userSelect:'none',
//         }}
//       >
//         {value ? (
//           <>
//             <div style={{ width:'28px', height:'28px', borderRadius:'7px', flexShrink:0, background: isDark ? T.darkBorder : '#EEF1FA', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px' }}>
//               {iconFn(value)}
//             </div>
//             <div style={{ flex:1, minWidth:0 }}>
//               <div style={{ fontSize:'13px', fontWeight:'600', color: isDark?T.darkText:T.text, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', fontFamily:T.bodyFont }}>{labelFn(value)}</div>
//               <div style={{ fontSize:'10px', letterSpacing:'1.5px', color:T.accent, fontWeight:'700', fontFamily:T.bodyFont, textTransform:'uppercase' }}>{subtitleFn(value)}</div>
//             </div>
//           </>
//         ) : (
//           <span style={{ fontSize:'13px', color: isDark?T.darkMuted:T.textLight, fontFamily:T.bodyFont }}>{placeholder || 'Select...'}</span>
//         )}
//         <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ flexShrink:0, marginLeft:'auto', transition:'transform .2s', transform: open?'rotate(180deg)':'none' }}>
//           <path d="M2 4l4 4 4-4" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//         </svg>
//       </div>

//       {open && (
//         <div style={{ position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:9999, background: isDark ? T.darkSurface : '#FFFFFF', border:`1.5px solid ${isDark?T.darkBorder:'#DDE3F0'}`, borderRadius:'12px', boxShadow:'0 12px 40px rgba(11,20,55,0.15)', overflow:'hidden', maxHeight:'300px', display:'flex', flexDirection:'column' }}>
//           <div style={{ padding:'10px 12px', borderBottom:`1px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
//             <div style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', borderRadius:'8px', background: isDark?T.darkSurface2:'#F4F6FB' }}>
//               <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="6" cy="6" r="4.5" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3"/><path d="M9.5 9.5l2 2" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3" strokeLinecap="round"/></svg>
//               <input autoFocus value={search} onChange={e => setSearch(e.target.value)} placeholder={`Search...`} style={{ border:'none', outline:'none', background:'transparent', fontSize:'13px', fontFamily:T.bodyFont, flex:1, color: isDark?T.darkText:T.text }} />
//               {search && <span onClick={() => setSearch('')} style={{ cursor:'pointer', color:isDark?T.darkMuted:T.textLight, fontSize:'16px' }}>×</span>}
//             </div>
//           </div>
//           <div style={{ overflowY:'auto', flex:1 }}>
//             {loading ? (
//               <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted }}>Loading...</div>
//             ) : filtered.length === 0 ? (
//               <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted }}>No results</div>
//             ) : filtered.map((opt, i) => {
//               const isSel = value && labelFn(value) === labelFn(opt);
//               return (
//                 <div key={opt._id || i} onClick={() => { onChange(opt); setOpen(false); setSearch(''); }}
//                   style={{ display:'flex', alignItems:'center', gap:'12px', padding:'11px 14px', cursor:'pointer', background: isSel ? (isDark?'rgba(13,71,161,0.15)':'#F0F4FF') : 'transparent', borderLeft: isSel ? `3px solid ${T.accent}` : '3px solid transparent', transition:'background .12s' }}
//                   onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = isDark?'rgba(255,255,255,0.04)':'#F8F9FD'; }}
//                   onMouseLeave={e => { e.currentTarget.style.background = isSel?(isDark?'rgba(13,71,161,0.15)':'#F0F4FF'):'transparent'; }}
//                 >
//                   <div style={{ width:'32px', height:'32px', borderRadius:'8px', flexShrink:0, background: isSel?(isDark?'rgba(13,71,161,0.25)':'#DDEAFF'):(isDark?T.darkBorder:'#EEF1FA'), display:'flex', alignItems:'center', justifyContent:'center', fontSize:'15px' }}>{iconFn(opt)}</div>
//                   <div style={{ flex:1, minWidth:0 }}>
//                     <div style={{ fontSize:'13px', fontWeight:isSel?'600':'500', color:isSel?T.accent:(isDark?T.darkText:T.text), fontFamily:T.bodyFont, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{labelFn(opt)}</div>
//                     <div style={{ fontSize:'10px', letterSpacing:'1.2px', fontWeight:'700', color:isSel?T.accent:(isDark?T.darkMuted:T.textLight), fontFamily:T.bodyFont, textTransform:'uppercase' }}>{subtitleFn(opt)}</div>
//                   </div>
//                   {isSel && <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke={T.accent} strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke={T.accent} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// /* ══════════════════════════════════════════════════════════════════════════
//    BULK EDIT PAGE
// ══════════════════════════════════════════════════════════════════════════ */
// export const BulkEditPage = () => {
//   const theme        = useTheme();
//   const isDark       = theme.palette.mode === 'dark';
//   const dispatch     = useDispatch();
//   const navigate     = useNavigate();
//   const sidebarWidth = useSidebarWidth();

//   const [userlogin, setUserlogin] = useState(null);
//   useEffect(() => {
//     try { const u = localStorage.getItem('user'); if (u) setUserlogin(JSON.parse(u)); } catch { setUserlogin(null); }
//   }, []);

//   /* ── قراءة الـ leads المحددة من localStorage ── */
//   const selectedLeads = React.useMemo(() => {
//     try { return JSON.parse(localStorage.getItem('selectedleeds') || '[]'); } catch { return []; }
//   }, []);

//   /* ── Fields ── */
//   const [name,             setName]             = useState('');
//   const [email,            setEmail]            = useState('');
//   const [note,             setNote]             = useState('');
//   const [project,          setProject]          = useState('');
//   const [channal,          setChannal]          = useState('');
//   const [communicationway, setCommunicationway] = useState('');
//   const [budget,           setBudget]           = useState('');
//   const [leedtype,         setLeedtype]         = useState('Fresh');
//   const [checked,          setChecked]          = useState(true);
//   const [campaignid,       setCampaignid]       = useState('');
//   const [jobDescription,   setJobDescription]   = useState('');
//   const [whatsappnumber,   setWhatsappnumber]   = useState('');
//   const [phonenumber2,     setPhonenumber2]     = useState('');
//   const [submitLoading,    setSubmitLoading]    = useState(false);

//   useEffect(() => { setLeedtype(checked ? 'Fresh' : 'Cold'); }, [checked]);

//   /* ── Load dropdowns ── */
//   useEffect(() => {
//     dispatch(GetallProjectsdata());
//     dispatch(GetAll_stage_Data());
//     dispatch(GetAllchannalData());
//     dispatch(GetCommunicationwayData());
//     dispatch(GetAllCampainData());
//   }, []);

//   const resGetProjectsData        = useSelector(s => s.AllProjects.Projects);
//   const resgetallchannal          = useSelector(s => s.AllChannalRoot.channal);
//   const resgetallcommunicationway = useSelector(s => s.AllCommunicationway.communicationway);
//   const resgetcampaindata         = useSelector(s => s.AllCampaign.campaign);

//   const get_all_Projects_data            = resGetProjectsData?.data || [];
//   const res_getallchannal_array          = Array.isArray(resgetallchannal?.data)          ? resgetallchannal.data          : [];
//   const res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data) ? resgetallcommunicationway.data : [];
//   const res_get_campaign_data_array      = Array.isArray(resgetcampaindata?.data)         ? resgetcampaindata.data         : [];

//   /* ── Submit ──────────────────────────────────────────────────────────────
//    *  بنبعت بس الـ fields اللي فيها قيمة حقيقية
//    *  name و email: لو فاضيين مش بيتبعتوا
//    * ─────────────────────────────────────────────────────────────────────── */
//   const onSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedLeads.length) {
//       Notify('error', 'No leads selected', 'Error');
//       return;
//     }

//     /* بناء الـ updateData بالـ fields اللي فيها قيمة بس */
//     const updateData = {};

//     if (name.trim())           updateData.name            = name.trim();
//     if (email.trim())          updateData.email           = email.trim();
//     if (project)               updateData.project         = project;
//     if (channal)               updateData.chanel          = channal;
//     if (communicationway)      updateData.communicationway= communicationway;
//     if (campaignid)            updateData.campaign        = campaignid;
//     if (leedtype)              updateData.leedtype        = leedtype;
//     if (budget !== '')         updateData.budget          = Number(budget);
//     if (note.trim())           updateData.notes           = note.trim();
//     if (jobDescription.trim()) updateData.jobdescription  = jobDescription.trim();
//     if (whatsappnumber.trim()) updateData.whatsappnumber  = whatsappnumber.trim();
//     if (phonenumber2.trim())   updateData.phonenumber2    = phonenumber2.trim();

//     if (Object.keys(updateData).length === 0) {
//       Notify('error', 'Please fill at least one field to update', 'Error');
//       return;
//     }

//     setSubmitLoading(true);
//     try {
//       const adminId = userlogin?.data?._id;
//       const { data } = await baseurl.put(
//         `api/v1/users/leads/bulk-edit/${adminId}`,
//         { leadIds: selectedLeads, updateData }
//       );

//       Notify('success', `${data.summary?.modified || 0} leads updated successfully`, 'Success');

//       /* reset */
//       setName(''); setEmail(''); setNote(''); setProject('');
//       setChannal(''); setCommunicationway(''); setBudget('');
//       setCampaignid(''); setJobDescription('');
//       setWhatsappnumber(''); setPhonenumber2('');
//       setChecked(true);

//       navigate(-1);
//     } catch (err) {
//       Notify('error', err?.response?.data?.message || 'Failed to update leads', 'Error');
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   /* ── Route helper ── */
//   const getHomeRoute = () => {
//     switch(userlogin?.data?.role) {
//       case 'Admin':    return '/AllLeadsForAdmin';
//       case 'Marketer': return '/ALLLeadsForMarketer';
//       default:         return '/';
//     }
//   };

//   const inputStyle = getInputStyle(isDark);

//   const getChannelIcon = (o) => {
//     const n = (o?.name||'').toLowerCase();
//     if (n.includes('social')||n.includes('instagram')||n.includes('facebook')) return '📱';
//     if (n.includes('email')) return '📧';
//     if (n.includes('referral')) return '🤝';
//     if (n.includes('web')||n.includes('site')) return '🌐';
//     if (n.includes('call')||n.includes('phone')) return '📞';
//     if (n.includes('whatsapp')) return '💬';
//     return '📡';
//   };
//   const getChannelSubtitle = (o) => {
//     const n = (o?.name||'').toLowerCase();
//     if (n.includes('social')) return 'DIGITAL MEDIA';
//     if (n.includes('referral')) return 'WORD OF MOUTH';
//     if (n.includes('web')) return 'ONLINE';
//     if (n.includes('email')) return 'EMAIL MARKETING';
//     return 'ACQUISITION CHANNEL';
//   };

//   /* ─────────────────────────
//      RENDER
//   ───────────────────────── */
//   return (
//     <div style={{
//       position:'fixed', top:'50px', left:sidebarWidth, right:0, bottom:0,
//       transition:'left 0.25s cubic-bezier(0.4,0,0.2,1)',
//       display:'flex', flexDirection:'column', overflow:'hidden',
//       backgroundColor: isDark ? T.darkBg : T.offWhite,
//       fontFamily: T.bodyFont,
//     }}>

//       {/* ── Breadcrumb ── */}
//       <div style={{
//         padding:'14px 28px', flexShrink:0,
//         backgroundColor: isDark ? T.darkSurface : T.offWhite,
//         display:'flex', alignItems:'center', gap:'8px', fontSize:'13px',
//       }}>
//         <Link to={getHomeRoute()} style={{ textDecoration:'none', color: isDark?'#9ca3af':'#6b7280', fontWeight:'500' }}>Home</Link>
//         <span style={{ color: isDark?'#4b5563':'#d1d5db' }}>/</span>
//         <span style={{ color: isDark?'#e5e7eb':'#111827', fontWeight:'600' }}>Bulk Edit Leads</span>
//       </div>

//       {/* ── Scrollable Body ── */}
//       <div style={{ flex:1, overflowY:'auto', overflowX:'hidden', display:'flex', flexDirection:'column' }}>
//         <div style={{ padding:'24px 28px', flex:1 }}>

//           {/* Page Heading */}
//           <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'28px' }}>
//             <div>
//               <div style={{ fontSize:T.labelSize, fontWeight:'700', letterSpacing:'2px', textTransform:'uppercase', color:T.accent, marginBottom:'6px', fontFamily:T.bodyFont }}>
//                 LEADS / BULK EDIT
//               </div>
//               <h1 style={{ fontFamily:T.sectionFont, fontSize:'34px', fontWeight:'700', color:isDark?T.darkText:T.text, margin:'0 0 6px', letterSpacing:'-0.5px' }}>
//                 Bulk Edit Leads
//               </h1>
//               <p style={{ margin:0, fontSize:'14px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'300' }}>
//                 Only filled fields will be updated across all selected leads.
//               </p>
//             </div>

//             {/* Selected leads counter */}
//             <div style={{
//               padding:'10px 20px', borderRadius:'12px',
//               background: isDark ? T.darkSurface : T.surface,
//               border:`1.5px solid ${T.accent}`,
//               display:'flex', alignItems:'center', gap:'10px',
//             }}>
//               <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:T.accent }} />
//               <div>
//                 <div style={{ fontSize:'22px', fontWeight:'800', color:T.accent, lineHeight:1, fontFamily:T.bodyFont }}>
//                   {selectedLeads.length}
//                 </div>
//                 <div style={{ fontSize:'10px', fontWeight:'700', letterSpacing:'1.5px', color:isDark?T.darkMuted:T.textMuted, textTransform:'uppercase' }}>
//                   Leads Selected
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ── Info Banner ── */}
//           <div style={{
//             display:'flex', alignItems:'center', gap:'12px',
//             padding:'14px 18px', borderRadius:'10px',
//             background: isDark ? 'rgba(13,71,161,0.12)' : '#EFF6FF',
//             border:`1.5px solid ${isDark?'rgba(13,71,161,0.3)':'#BFDBFE'}`,
//             marginBottom:'24px',
//           }}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={T.accent} strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
//             <span style={{ fontSize:'13px', color: isDark?'#93C5FD':T.accent, fontWeight:'500', fontFamily:T.bodyFont }}>
//               Leave any field empty to keep its current value unchanged across all leads.
//               <strong> Name</strong> and <strong>Email</strong> will only update if you type a value.
//             </span>
//           </div>

//           {/* ══ SECTION 01 / IDENTITY ══ */}
//           <SectionCard isDark={isDark}>
//             <SectionTag number={1} label="Identity" />
//             <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px' }}>

//               <div>
//                 <FieldLabel isDark={isDark}>Full Name (Optional — leave empty to keep current)</FieldLabel>
//                 <input value={name} onChange={e=>setName(e.target.value)} style={inputStyle}
//                   type="text" placeholder="Update name across all leads..."
//                   onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                   onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                 />
//               </div>

//               <div>
//                 <FieldLabel isDark={isDark}>Email Address (Optional — leave empty to keep current)</FieldLabel>
//                 <input value={email} onChange={e=>setEmail(e.target.value)} style={inputStyle}
//                   type="email" placeholder="Update email across all leads..."
//                   onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                   onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                 />
//               </div>

           

           

//             </div>
//           </SectionCard>

//           {/* ══ SECTION 02 + 03 ══ */}
//           <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px', marginBottom:'20px' }}>

//             {/* ── SECTION 02 / ACQUISITION ── */}
//             <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
//               <SectionTag number={2} label="Acquisition" />
//               <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

//                 {/* Project */}
//                 <div>
//                   <FieldLabel isDark={isDark}>Project</FieldLabel>
//                   <LuxuryAutocomplete
//                     options={get_all_Projects_data}
//                     value={get_all_Projects_data.find(p => p._id === project) || null}
//                     onChange={v => setProject(v ? v._id : '')}
//                     placeholder="Select project to apply to all"
//                     isDark={isDark}
//                   />
//                 </div>

//                 {/* Campaign + Channel */}
//                 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
//                   <div>
//                     <FieldLabel isDark={isDark}>Campaign</FieldLabel>
//                     <LuxuryAutocomplete
//                       options={res_get_campaign_data_array}
//                       value={res_get_campaign_data_array.find(i => i._id === campaignid) || null}
//                       onChange={v => setCampaignid(v ? v._id : '')}
//                       placeholder="Select campaign"
//                       isDark={isDark}
//                       getLabel={o => o?.CampainName || ''}
//                       getIcon={() => '📣'}
//                       getSubtitle={() => 'CAMPAIGN'}
//                     />
//                   </div>
//                   <div>
//                     <FieldLabel isDark={isDark}>Channel</FieldLabel>
//                     <LuxuryAutocomplete
//                       options={res_getallchannal_array}
//                       value={res_getallchannal_array.find(i => i._id === channal) || null}
//                       onChange={v => setChannal(v ? v._id : '')}
//                       placeholder="Select channel"
//                       isDark={isDark}
//                       getIcon={getChannelIcon}
//                       getSubtitle={getChannelSubtitle}
//                     />
//                   </div>
//                 </div>

//                 {/* Communication Way */}
//                 <div>
//                   <FieldLabel isDark={isDark}>Communication Way</FieldLabel>
//                   <div style={{ display:'flex', flexWrap:'wrap', gap:'8px', marginTop:'4px' }}>
//                     {res_getallcommunicationway_array.length > 0
//                       ? [...res_getallcommunicationway_array]
//                           .sort((a,b) => a.name==='No Communication Way'?-1:b.name==='No Communication Way'?1:0)
//                           .slice(0,6)
//                           .map(item => (
//                             <button key={item._id}
//                               onClick={() => setCommunicationway(communicationway===item._id?'':item._id)}
//                               style={{
//                                 padding:'7px 16px', borderRadius:'20px', fontSize:'12px',
//                                 fontFamily:T.bodyFont, fontWeight:'500', cursor:'pointer',
//                                 border: communicationway===item._id ? `1.5px solid ${T.accent}` : `1.5px solid ${isDark?T.darkBorder:T.border}`,
//                                 background: communicationway===item._id ? T.accentBg : isDark?T.darkSurface2:'#FAFBFF',
//                                 color: communicationway===item._id ? T.accent : isDark?T.darkMuted:T.textMuted,
//                                 transition:'all .15s',
//                               }}
//                             >{item.name}</button>
//                           ))
//                       : <span style={{ fontSize:'13px', color:isDark?T.darkMuted:T.textLight }}>No options available</span>
//                     }
//                   </div>
//                 </div>

//                 {/* Lead Type */}
//                 <div style={{ display:'flex', alignItems:'center', gap:'12px', padding:'12px 14px', background:isDark?T.darkSurface2:T.offWhite, borderRadius:'10px', border:`1.5px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
//                   <span style={{ fontSize:'11px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'700', letterSpacing:'1px', textTransform:'uppercase' }}>Lead Type:</span>
//                   <Switch
//                     checked={checked}
//                     onChange={e => setChecked(e.target.checked)}
//                     size="small"
//                     sx={{
//                       '& .MuiSwitch-thumb': { background: checked?T.success:(isDark?T.darkMuted:T.textMuted) },
//                       '& .Mui-checked+.MuiSwitch-track': { background:T.success+'66 !important', opacity:'1 !important' },
//                     }}
//                   />
//                   <span style={{ fontSize:'13px', color:checked?T.success:(isDark?T.darkMuted:T.textMuted), fontWeight:'500' }}>
//                     {checked ? '● Fresh Lead' : '● Cold Lead'}
//                   </span>
//                 </div>

//               </div>
//             </div>

//             {/* ── SECTION 03 / NARRATIVE ── */}
//             <div style={{ background:isDark?T.darkSurface:T.surface, border:`1px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'12px', padding:'28px' }}>
//               <SectionTag number={3} label="Narrative" />
//               <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

//                 <div>
//                   <FieldLabel isDark={isDark}>Job Description (Optional)</FieldLabel>
//                   <textarea value={jobDescription} onChange={e=>setJobDescription(e.target.value)} rows={3}
//                     style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
//                     placeholder="Professional background..."
//                     onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                     onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                   />
//                 </div>

//                 <div>
//                   <FieldLabel isDark={isDark}>Budget Allocation (Optional)</FieldLabel>
//                   <div style={{ position:'relative' }}>
//                     <span style={{ position:'absolute', left:'14px', top:'50%', transform:'translateY(-50%)', color:isDark?T.darkMuted:T.textMuted, fontSize:'14px', fontWeight:'600' }}>$</span>
//                     <input value={budget} onChange={e=>setBudget(e.target.value)}
//                       style={{ ...inputStyle, paddingLeft:'30px' }} type="number" placeholder="5,000,000"
//                       onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                       onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                     />
//                   </div>
//                 </div>

//                 <div>
//                   <FieldLabel isDark={isDark}>Internal Notes (Optional)</FieldLabel>
//                   <textarea value={note} onChange={e=>setNote(e.target.value)} rows={5}
//                     style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }}
//                     placeholder="Notes to apply across all selected leads..."
//                     onFocus={e=>{ e.target.style.borderColor=T.accent; e.target.style.boxShadow=`0 0 0 3px rgba(13,71,161,0.08)`; }}
//                     onBlur={e=>{  e.target.style.borderColor=isDark?T.darkBorder:T.border; e.target.style.boxShadow='none'; }}
//                   />
//                 </div>

//               </div>
//             </div>
//           </div>

//           {/* ══ ACTIONS ══ */}
//           <div style={{ display:'flex', justifyContent:'flex-end', gap:'12px', padding:'8px 0 16px' }}>
//             <button
//               onClick={() => navigate(-1)}
//               style={{ padding:'11px 28px', background:'transparent', border:`1.5px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'10px', color:isDark?T.darkMuted:T.textMuted, fontSize:'13px', fontWeight:'500', cursor:'pointer', fontFamily:T.bodyFont }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={!submitLoading ? onSubmit : undefined}
//               disabled={submitLoading || selectedLeads.length === 0}
//               style={{ padding:'11px 32px', background:T.accent, border:'none', borderRadius:'10px', color:'#fff', fontSize:'13px', fontWeight:'600', cursor:(submitLoading||!selectedLeads.length)?'not-allowed':'pointer', fontFamily:T.bodyFont, display:'flex', alignItems:'center', gap:'8px', opacity:(submitLoading||!selectedLeads.length)?0.65:1, transition:'all .2s' }}
//             >
//               {submitLoading
//                 ? <><CircularProgress size={16} style={{ color:'white' }} /> Saving Changes...</>
//                 : <><EditIcon style={{ fontSize:'17px' }} /> Apply to {selectedLeads.length} Lead{selectedLeads.length!==1?'s':''}</>
//               }
//             </button>
//           </div>

//           {/* ══ FOOTER BANNER ══ */}
//           <div style={{ borderRadius:'12px', overflow:'hidden', background:`linear-gradient(135deg, ${T.navy} 0%, ${T.navyLight} 40%, #1a2f6e 100%)`, padding:'36px', marginBottom:'8px', position:'relative' }}>
//             <div style={{ position:'absolute', inset:0, opacity:0.06, backgroundImage:'repeating-linear-gradient(45deg, transparent, transparent 20px, rgba(255,255,255,0.4) 20px, rgba(255,255,255,0.4) 21px)' }} />
//             <div style={{ position:'relative', zIndex:1 }}>
//               <div style={{ fontSize:'10px', letterSpacing:'2.5px', color:T.gold, fontWeight:'700', textTransform:'uppercase', marginBottom:'10px', fontFamily:T.bodyFont }}>Executive Principle</div>
//               <blockquote style={{ fontFamily:T.sectionFont, fontSize:'20px', fontWeight:'600', color:'#fff', margin:0, lineHeight:'1.5', fontStyle:'italic' }}>
//                 "Precision in data is the foundation of every elite conversion."
//               </blockquote>
//             </div>
//           </div>

//         </div>

//         {/* Footer */}
//         <footer style={{ padding:'16px 28px', flexShrink:0, fontSize:'12px', color:isDark?'#4b5563':'#9ca3af', fontFamily:T.bodyFont, borderTop:`1px solid ${isDark?T.darkBorder:T.border}`, textAlign:'center' }}>
//           © 2026 Realatix CRM • Secure Multi-Tenant Architecture
//         </footer>
//       </div>
//     </div>
//   );
// };









































import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Drawer, Box, IconButton, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { Notify } from '../Utility/Notify';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
import baseurl from '../Api/BaseUrl';

/* ───── Design tokens (same family) ───── */
const T = {
  navy: '#0B1437', accent: '#0D47A1', accentBg: 'rgba(26,60,219,0.08)',
  white: '#FFFFFF', offWhite: '#f0f2f5', surface: '#FFFFFF',
  border: '#DDE3F0', borderLight: '#EEF1FA', text: '#0B1437',
  textMuted: '#6B7694', textLight: '#9BA5C9', gold: '#C8A96E',
  danger: '#E24B4A', success: '#1D9E75', labelSize: '11px',
  sectionFont: "'DM Sans', 'Georgia', sans-serif", bodyFont: "'DM Sans', sans-serif",
  darkBg: '#FFFFFF', darkSurface: '#FFFFFF', darkSurface2: '#161929',
  darkBorder: '#2a2f45', darkText: '#e5e7eb', darkMuted: '#6b7280',
};

const SectionTag = ({ number, label }) => (
  <div style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'16px' }}>
    <div style={{ width:'24px', height:'2px', background: T.accent }} />
    <span style={{ fontFamily:T.bodyFont, fontSize:T.labelSize, fontWeight:'700', letterSpacing:'2px', color:T.accent, textTransform:'uppercase' }}>
      Section {String(number).padStart(2,'0')} / {label}
    </span>
  </div>
);

const FieldLabel = ({ children, isDark }) => (
  <label style={{ display:'block', marginBottom:'6px', fontFamily:T.bodyFont, fontSize:T.labelSize, fontWeight:'700', letterSpacing:'1.5px', textTransform:'uppercase', color: isDark ? T.darkMuted : T.textMuted }}>
    {children}
  </label>
);

const getInputStyle = (isDark) => ({
  width:'100%', padding:'10px 14px', borderRadius:'10px',
  border:`1.5px solid ${isDark ? T.darkBorder : T.border}`,
  background: isDark ? T.darkSurface2 : '#FAFBFF',
  color: isDark ? T.darkText : T.text,
  fontSize:'13px', fontFamily:T.bodyFont, outline:'none',
  transition:'border-color .2s, box-shadow .2s', boxSizing:'border-box',
});

const SectionCard = ({ children, isDark, style }) => (
  <div style={{ background: isDark ? T.darkSurface : T.surface, border:`1px solid ${isDark ? T.darkBorder : T.border}`, borderRadius:'12px', padding:'22px', marginBottom:'18px', ...style }}>
    {children}
  </div>
);

const getProjectIcon = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('villa') || n.includes('residence')) return '🏡';
  if (n.includes('beach') || n.includes('leisure') || n.includes('oasis')) return '🏖';
  if (n.includes('commercial') || n.includes('hub')) return '🏗';
  if (n.includes('logistic') || n.includes('industrial')) return '🏭';
  if (n.includes('urban') || n.includes('city')) return '🏙';
  if (n.includes('luxury') || n.includes('premium')) return '💎';
  return '🏢';
};
const getProjectSubtitle = (name = '') => {
  const n = name.toLowerCase();
  if (n.includes('villa')) return 'LUXURY LIVING';
  if (n.includes('beach') || n.includes('oasis')) return 'LEISURE ESTATES';
  if (n.includes('commercial') || n.includes('hub')) return 'COMMERCIAL HUB';
  if (n.includes('logistic')) return 'INDUSTRIAL';
  if (n.includes('urban')) return 'URBAN PORTFOLIO';
  if (n.includes('residence') || n.includes('tower')) return 'RESIDENTIAL';
  return 'REAL ESTATE';
};

/* ───── Autocomplete (same component, نفس اللي في الصفحة الأصلية) ───── */
const LuxuryAutocomplete = ({ options = [], value, onChange, placeholder, loading, isDark, getLabel, getSubtitle, getIcon, disabled }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = React.useRef(null);

  const labelFn    = getLabel    || (o => o?.name || '');
  const subtitleFn = getSubtitle || (o => getProjectSubtitle(o?.name || ''));
  const iconFn     = getIcon     || (o => getProjectIcon(o?.name || ''));
  const filtered   = options.filter(o => labelFn(o).toLowerCase().includes(search.toLowerCase()));

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div ref={ref} style={{ position:'relative', width:'100%' }}>
      <div
        onClick={() => !disabled && setOpen(o => !o)}
        style={{
          display:'flex', alignItems:'center', gap:'10px',
          padding:'0 14px', height:'42px', borderRadius:'10px',
          border:`1.5px solid ${open ? T.accent : isDark ? T.darkBorder : T.border}`,
          background: isDark ? T.darkSurface2 : '#FAFBFF',
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition:'border-color .2s',
          boxShadow: open ? `0 0 0 3px rgba(13,71,161,0.08)` : 'none',
          opacity: disabled ? 0.6 : 1, userSelect:'none',
        }}
      >
        {value ? (
          <>
            <div style={{ width:'28px', height:'28px', borderRadius:'7px', flexShrink:0, background: isDark ? T.darkBorder : '#EEF1FA', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px' }}>
              {iconFn(value)}
            </div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:'13px', fontWeight:'600', color: isDark?T.darkText:T.text, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', fontFamily:T.bodyFont }}>{labelFn(value)}</div>
              <div style={{ fontSize:'10px', letterSpacing:'1.5px', color:T.accent, fontWeight:'700', fontFamily:T.bodyFont, textTransform:'uppercase' }}>{subtitleFn(value)}</div>
            </div>
          </>
        ) : (
          <span style={{ fontSize:'13px', color: isDark?T.darkMuted:T.textLight, fontFamily:T.bodyFont }}>{placeholder || 'Select...'}</span>
        )}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ flexShrink:0, marginLeft:'auto', transition:'transform .2s', transform: open?'rotate(180deg)':'none' }}>
          <path d="M2 4l4 4 4-4" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      {open && (
        <div style={{ position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:9999, background: isDark ? T.darkSurface : '#FFFFFF', border:`1.5px solid ${isDark?T.darkBorder:'#DDE3F0'}`, borderRadius:'12px', boxShadow:'0 12px 40px rgba(11,20,55,0.15)', overflow:'hidden', maxHeight:'280px', display:'flex', flexDirection:'column' }}>
          <div style={{ padding:'10px 12px', borderBottom:`1px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', borderRadius:'8px', background: isDark?T.darkSurface2:'#F4F6FB' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="6" cy="6" r="4.5" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3"/><path d="M9.5 9.5l2 2" stroke={isDark?T.darkMuted:T.textMuted} strokeWidth="1.3" strokeLinecap="round"/></svg>
              <input autoFocus value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..." style={{ border:'none', outline:'none', background:'transparent', fontSize:'13px', fontFamily:T.bodyFont, flex:1, color: isDark?T.darkText:T.text }} />
              {search && <span onClick={() => setSearch('')} style={{ cursor:'pointer', color:isDark?T.darkMuted:T.textLight, fontSize:'16px' }}>×</span>}
            </div>
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            {loading ? (
              <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted }}>Loading...</div>
            ) : filtered.length === 0 ? (
              <div style={{ padding:'20px', textAlign:'center', fontSize:'13px', color:isDark?T.darkMuted:T.textMuted }}>No results</div>
            ) : filtered.map((opt, i) => {
              const isSel = value && labelFn(value) === labelFn(opt);
              return (
                <div key={opt._id || i} onClick={() => { onChange(opt); setOpen(false); setSearch(''); }}
                  style={{ display:'flex', alignItems:'center', gap:'12px', padding:'11px 14px', cursor:'pointer', background: isSel ? (isDark?'rgba(13,71,161,0.15)':'#F0F4FF') : 'transparent', borderLeft: isSel ? `3px solid ${T.accent}` : '3px solid transparent', transition:'background .12s' }}
                  onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = isDark?'rgba(255,255,255,0.04)':'#F8F9FD'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = isSel?(isDark?'rgba(13,71,161,0.15)':'#F0F4FF'):'transparent'; }}
                >
                  <div style={{ width:'32px', height:'32px', borderRadius:'8px', flexShrink:0, background: isSel?(isDark?'rgba(13,71,161,0.25)':'#DDEAFF'):(isDark?T.darkBorder:'#EEF1FA'), display:'flex', alignItems:'center', justifyContent:'center', fontSize:'15px' }}>{iconFn(opt)}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:'13px', fontWeight:isSel?'600':'500', color:isSel?T.accent:(isDark?T.darkText:T.text), fontFamily:T.bodyFont, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{labelFn(opt)}</div>
                    <div style={{ fontSize:'10px', letterSpacing:'1.2px', fontWeight:'700', color:isSel?T.accent:(isDark?T.darkMuted:T.textLight), fontFamily:T.bodyFont, textTransform:'uppercase' }}>{subtitleFn(opt)}</div>
                  </div>
                  {isSel && <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke={T.accent} strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke={T.accent} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   BULK EDIT DRAWER
   Props:
   - open: boolean
   - onClose: () => void
   - selectedLeads: string[]   (lead ids)
   - onSuccess: () => void     (يتنفذ بعد التحديث بنجاح، تستخدمه عشان تـ refresh الجدول وتفضي السيلكشن)
══════════════════════════════════════════════════════════ */
export const BulkEditDrawer = ({ open, onClose, selectedLeads = [], onSuccess }) => {
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';
  const dispatch = useDispatch();

  const [userlogin, setUserlogin] = useState(null);
  useEffect(() => {
    try { const u = localStorage.getItem('user'); if (u) setUserlogin(JSON.parse(u)); } catch { setUserlogin(null); }
  }, []);

  const [name,             setName]             = useState('');
  const [email,            setEmail]            = useState('');
  const [note,             setNote]             = useState('');
  const [project,          setProject]          = useState('');
  const [channal,          setChannal]          = useState('');
  const [communicationway, setCommunicationway] = useState('');
  const [budget,           setBudget]           = useState('');
  const [leedtype,         setLeedtype]         = useState('Fresh');
  const [checked,          setChecked]          = useState(true);
  const [campaignid,       setCampaignid]       = useState('');
  const [jobDescription,   setJobDescription]   = useState('');
  const [whatsappnumber,   setWhatsappnumber]   = useState('');
  const [phonenumber2,     setPhonenumber2]     = useState('');
  const [submitLoading,    setSubmitLoading]    = useState(false);

  useEffect(() => { setLeedtype(checked ? 'Fresh' : 'Cold'); }, [checked]);

  const resetFields = () => {
    setName(''); setEmail(''); setNote(''); setProject('');
    setChannal(''); setCommunicationway(''); setBudget('');
    setCampaignid(''); setJobDescription('');
    setWhatsappnumber(''); setPhonenumber2(''); setChecked(true);
  };

  /* تحميل الـ dropdowns بس وقت ما الـ drawer يفتح */
  useEffect(() => {
    if (!open) return;
    dispatch(GetallProjectsdata());
    dispatch(GetAll_stage_Data());
    dispatch(GetAllchannalData());
    dispatch(GetCommunicationwayData());
    dispatch(GetAllCampainData());
    resetFields();
  }, [open]);

  const resGetProjectsData        = useSelector(s => s.AllProjects.Projects);
  const resgetallchannal          = useSelector(s => s.AllChannalRoot.channal);
  const resgetallcommunicationway = useSelector(s => s.AllCommunicationway.communicationway);
  const resgetcampaindata         = useSelector(s => s.AllCampaign.campaign);

  const get_all_Projects_data            = resGetProjectsData?.data || [];
  const res_getallchannal_array          = Array.isArray(resgetallchannal?.data)          ? resgetallchannal.data          : [];
  const res_getallcommunicationway_array = Array.isArray(resgetallcommunicationway?.data) ? resgetallcommunicationway.data : [];
  const res_get_campaign_data_array      = Array.isArray(resgetcampaindata?.data)         ? resgetcampaindata.data         : [];

  const onSubmit = async () => {
    if (!selectedLeads.length) {
      Notify('error', 'No leads selected', 'Error');
      return;
    }

    const updateData = {};
    if (name.trim())           updateData.name             = name.trim();
    if (email.trim())          updateData.email            = email.trim();
    if (project)               updateData.project          = project;
    if (channal)               updateData.chanel           = channal;
    if (communicationway)      updateData.communicationway = communicationway;
    if (campaignid)            updateData.campaign         = campaignid;
    if (leedtype)              updateData.leedtype         = leedtype;
    if (budget !== '')         updateData.budget           = Number(budget);
    if (note.trim())           updateData.notes            = note.trim();
    if (jobDescription.trim()) updateData.jobdescription   = jobDescription.trim();
    if (whatsappnumber.trim()) updateData.whatsappnumber   = whatsappnumber.trim();
    if (phonenumber2.trim())   updateData.phonenumber2     = phonenumber2.trim();

    if (Object.keys(updateData).length === 0) {
      Notify('error', 'Please fill at least one field to update', 'Error');
      return;
    }

    setSubmitLoading(true);
    try {
      const adminId = userlogin?.data?._id;
      const { data } = await baseurl.put(
        `api/v1/users/leads/bulk-edit/${adminId}`,
        { leadIds: selectedLeads, updateData }
      );
      Notify('success', `${data.summary?.modified || 0} leads updated successfully`, 'Success');
      resetFields();
      onClose();
      onSuccess && onSuccess();
    } catch (err) {
      Notify('error', err?.response?.data?.message || 'Failed to update leads', 'Error');
    } finally {
      setSubmitLoading(false);
    }
  };

  const inputStyle = getInputStyle(isDark);

  const getChannelIcon = (o) => {
    const n = (o?.name||'').toLowerCase();
    if (n.includes('social')||n.includes('instagram')||n.includes('facebook')) return '📱';
    if (n.includes('email')) return '📧';
    if (n.includes('referral')) return '🤝';
    if (n.includes('web')||n.includes('site')) return '🌐';
    if (n.includes('call')||n.includes('phone')) return '📞';
    if (n.includes('whatsapp')) return '💬';
    return '📡';
  };
  const getChannelSubtitle = (o) => {
    const n = (o?.name||'').toLowerCase();
    if (n.includes('social')) return 'DIGITAL MEDIA';
    if (n.includes('referral')) return 'WORD OF MOUTH';
    if (n.includes('web')) return 'ONLINE';
    if (n.includes('email')) return 'EMAIL MARKETING';
    return 'ACQUISITION CHANNEL';
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => !submitLoading && onClose()}
      PaperProps={{ sx: { width: { xs:'100%',sm: '60%',md:'60% !important' }, bgcolor:'#fff !importnat' } }}
    >
      <Box sx={{ display:'flex',background:'#fff !important',width:'100% !important', flexDirection:'column', height:'100%' }}>

        {/* Header */}
        <Box sx={{
          px:3, py:2.2, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'space-between',
          background: isDark ? T.darkSurface : T.surface, borderBottom:`1px solid ${isDark?T.darkBorder:T.border}`,
        }}>
          <Box>
            <div style={{ fontSize:T.labelSize, fontWeight:700, letterSpacing:'2px', textTransform:'uppercase', color:T.accent, marginBottom:'4px', fontFamily:T.bodyFont }}>
              LEADS / BULK EDIT
            </div>
            <Typography sx={{ fontFamily:T.sectionFont, fontSize:'22px', fontWeight:700, color: isDark?T.darkText:T.text, letterSpacing:'-0.4px' }}>
              Bulk Edit Leads
            </Typography>
          </Box>
          <IconButton onClick={() => !submitLoading && onClose()} sx={{ color: isDark?T.darkMuted:T.textMuted }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Body (scrollable) */}
        <Box sx={{ flex:1, overflowY:'auto', px:3, py:2.5 }}>

          {/* Counter + info */}
          <Box sx={{
            display:'flex', alignItems:'center', gap:'10px', padding:'10px 14px', borderRadius:'10px',
            background: isDark ? 'rgba(13,71,161,0.12)' : '#EFF6FF',
            border:`1.5px solid ${isDark?'rgba(13,71,161,0.3)':'#BFDBFE'}`, marginBottom:'18px',
          }}>
            <div style={{ width:'8px', height:'8px', borderRadius:'50%', background:T.accent, flexShrink:0 }} />
            <span style={{ fontSize:'13px', color: isDark?'#93C5FD':T.accent, fontWeight:600, fontFamily:T.bodyFont }}>
              Applying to {selectedLeads.length} lead{selectedLeads.length !== 1 ? 's' : ''}.
            </span>
            <span style={{ fontSize:'12px', color: isDark?'#93C5FD':T.accent, fontWeight:400, fontFamily:T.bodyFont }}>
              Leave a field empty to keep current value.
            </span>
          </Box>

          {/* Section 01 / Identity */}
          <SectionCard isDark={isDark}>
            <SectionTag number={1} label="Identity" />
            <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
              <div>
                <FieldLabel isDark={isDark}>Full Name (Optional)</FieldLabel>
                <input value={name} onChange={e=>setName(e.target.value)} style={inputStyle} type="text" placeholder="Update name across all leads..." />
              </div>
              <div>
                <FieldLabel isDark={isDark}>Email Address (Optional)</FieldLabel>
                <input value={email} onChange={e=>setEmail(e.target.value)} style={inputStyle} type="email" placeholder="Update email across all leads..." />
              </div>
            </div>
          </SectionCard>

          {/* Section 02 / Acquisition */}
          <SectionCard isDark={isDark}>
            <SectionTag number={2} label="Acquisition" />
            <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

              <div>
                <FieldLabel isDark={isDark}>Project</FieldLabel>
                <LuxuryAutocomplete
                  options={get_all_Projects_data}
                  value={get_all_Projects_data.find(p => p._id === project) || null}
                  onChange={v => setProject(v ? v._id : '')}
                  placeholder="Select project to apply to all"
                  isDark={isDark}
                />
              </div>

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
                <div>
                  <FieldLabel isDark={isDark}>Campaign</FieldLabel>
                  <LuxuryAutocomplete
                    options={res_get_campaign_data_array}
                    value={res_get_campaign_data_array.find(i => i._id === campaignid) || null}
                    onChange={v => setCampaignid(v ? v._id : '')}
                    placeholder="Select campaign"
                    isDark={isDark}
                    getLabel={o => o?.CampainName || ''}
                    getIcon={() => '📣'}
                    getSubtitle={() => 'CAMPAIGN'}
                  />
                </div>
                <div>
                  <FieldLabel isDark={isDark}>Channel</FieldLabel>
                  <LuxuryAutocomplete
                    options={res_getallchannal_array}
                    value={res_getallchannal_array.find(i => i._id === channal) || null}
                    onChange={v => setChannal(v ? v._id : '')}
                    placeholder="Select channel"
                    isDark={isDark}
                    getIcon={getChannelIcon}
                    getSubtitle={getChannelSubtitle}
                  />
                </div>
              </div>

              <div>
                <FieldLabel isDark={isDark}>Communication Way</FieldLabel>
                <div style={{ display:'flex', flexWrap:'wrap', gap:'8px', marginTop:'4px' }}>
                  {res_getallcommunicationway_array.length > 0
                    ? [...res_getallcommunicationway_array]
                        .sort((a,b) => a.name==='No Communication Way'?-1:b.name==='No Communication Way'?1:0)
                        .slice(0,6)
                        .map(item => (
                          <button key={item._id}
                            onClick={() => setCommunicationway(communicationway===item._id?'':item._id)}
                            style={{
                              padding:'7px 16px', borderRadius:'20px', fontSize:'12px',
                              fontFamily:T.bodyFont, fontWeight:'500', cursor:'pointer',
                              border: communicationway===item._id ? `1.5px solid ${T.accent}` : `1.5px solid ${isDark?T.darkBorder:T.border}`,
                              background: communicationway===item._id ? T.accentBg : isDark?T.darkSurface2:'#FAFBFF',
                              color: communicationway===item._id ? T.accent : isDark?T.darkMuted:T.textMuted,
                            }}
                          >{item.name}</button>
                        ))
                    : <span style={{ fontSize:'13px', color:isDark?T.darkMuted:T.textLight }}>No options available</span>
                  }
                </div>
              </div>

              <div style={{ display:'flex', alignItems:'center', gap:'12px', padding:'12px 14px', background:isDark?T.darkSurface2:T.offWhite, borderRadius:'10px', border:`1.5px solid ${isDark?T.darkBorder:'#EEF1FA'}` }}>
                <span style={{ fontSize:'11px', color:isDark?T.darkMuted:T.textMuted, fontWeight:'700', letterSpacing:'1px', textTransform:'uppercase' }}>Lead Type:</span>
                <Switch
                  checked={checked}
                  onChange={e => setChecked(e.target.checked)}
                  size="small"
                  sx={{
                    '& .MuiSwitch-thumb': { background: checked?T.success:(isDark?T.darkMuted:T.textMuted) },
                    '& .Mui-checked+.MuiSwitch-track': { background:T.success+'66 !important', opacity:'1 !important' },
                  }}
                />
                <span style={{ fontSize:'13px', color:checked?T.success:(isDark?T.darkMuted:T.textMuted), fontWeight:'500' }}>
                  {checked ? '● Fresh Lead' : '● Cold Lead'}
                </span>
              </div>
            </div>
          </SectionCard>

          {/* Section 03 / Narrative */}
          <SectionCard isDark={isDark}>
            <SectionTag number={3} label="Narrative" />
            <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
              <div>
                <FieldLabel isDark={isDark}>Job Description (Optional)</FieldLabel>
                <textarea value={jobDescription} onChange={e=>setJobDescription(e.target.value)} rows={3}
                  style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }} placeholder="Professional background..." />
              </div>
              <div>
                <FieldLabel isDark={isDark}>Budget Allocation (Optional)</FieldLabel>
                <div style={{ position:'relative' }}>
                  <span style={{ position:'absolute', left:'14px', top:'50%', transform:'translateY(-50%)', color:isDark?T.darkMuted:T.textMuted, fontSize:'14px', fontWeight:'600' }}>$</span>
                  <input value={budget} onChange={e=>setBudget(e.target.value)} style={{ ...inputStyle, paddingLeft:'30px' }} type="number" placeholder="5,000,000" />
                </div>
              </div>
             
              <div>
                <FieldLabel isDark={isDark}>Internal Notes (Optional)</FieldLabel>
                <textarea value={note} onChange={e=>setNote(e.target.value)} rows={4}
                  style={{ ...inputStyle, resize:'vertical', lineHeight:'1.6' }} placeholder="Notes to apply across all selected leads..." />
              </div>
            </div>
          </SectionCard>

        </Box>

        {/* Footer actions (sticky) */}
        <Box sx={{
          flexShrink:0, display:'flex', justifyContent:'flex-end', gap:'12px',
          px:3, py:2, borderTop:`1px solid ${isDark?T.darkBorder:T.border}`,
          background: isDark ? T.darkSurface : T.surface,
        }}>
          <button
            onClick={() => !submitLoading && onClose()}
            style={{ padding:'11px 24px', background:'transparent', border:`1.5px solid ${isDark?T.darkBorder:T.border}`, borderRadius:'10px', color:isDark?T.darkMuted:T.textMuted, fontSize:'13px', fontWeight:'500', cursor:'pointer', fontFamily:T.bodyFont }}
          >
            Cancel
          </button>
          <button
            onClick={!submitLoading ? onSubmit : undefined}
            disabled={submitLoading || selectedLeads.length === 0}
            style={{ padding:'11px 28px', background:T.accent, border:'none', borderRadius:'10px', color:'#fff', fontSize:'13px', fontWeight:'600', cursor:(submitLoading||!selectedLeads.length)?'not-allowed':'pointer', fontFamily:T.bodyFont, display:'flex', alignItems:'center', gap:'8px', opacity:(submitLoading||!selectedLeads.length)?0.65:1 }}
          >
            {submitLoading
              ? <><CircularProgress size={16} style={{ color:'white' }} /> Saving...</>
              : <><EditIcon style={{ fontSize:'17px' }} /> Apply to {selectedLeads.length} Lead{selectedLeads.length!==1?'s':''}</>
            }
          </button>
        </Box>
      </Box>
    </Drawer>
  );
};